import { useEffect } from 'react'
import { useStateContext } from '../../context/StateContextAPI'
import { CompactLogo, MainBackgroundVector, RokkApp } from '../../assets'
import { NewsletterForm } from '../../components'
import useGoogleTag from '../../utils/gtag'
import { useTranslation } from 'react-i18next'
import './rokk.page.css'

const RokkPage = () => {
    const gtag = process.env.REACT_APP_GOOGLE_TAG || ""
    useGoogleTag(gtag)

    const { setActivePage } = useStateContext()
    const { t } = useTranslation()

    useEffect(() => {
        setActivePage(() => "rokk")
        window.scrollTo(0, 0)
    }, [setActivePage])

    const features = [
        t('rokk.feature1'),
        t('rokk.feature2'),
        t('rokk.feature3'),
        t('rokk.feature4'),
        t('rokk.feature5'),
        t('rokk.feature6'),
        t('rokk.feature7'),
    ]

    return (
        <div className="rokk-app-page">
            <img src={MainBackgroundVector} alt="" className="rokk-hero-bg" />

            {/* Hero Section */}
            <div className="rokk-hero-section">
                <div className="rokk-hero-content">
                    <span className="rokk-hero-label">{t('rokk.heroLabel')}</span>
                    <div className="rokk-hero-title">
                        <span className="head-txt-off-white">{t('rokk.heroTitle1')}</span>
                        <span className="head-txt-primary">{t('rokk.heroTitle2')}</span>
                    </div>
                    <p className="rokk-hero-subtitle">
                        {t('rokk.heroSubtitle')}
                    </p>
                </div>
                <div className="rokk-hero-image">
                    <img src={RokkApp} alt="ROKK App" />
                </div>
            </div>

            {/* Features Section */}
            <div className="rokk-features-section">
                <div className="rokk-features-left">
                    <div className="rokk-features-header">
                        <span className="head-txt-off-white">{t('rokk.featuresTitle')}</span>
                    </div>
                    <p className="rokk-features-subtitle">{t('rokk.featuresSubtitle')}</p>
                </div>
                <div className="rokk-features-list">
                    {features.map((feature, index) => (
                        <div className="rokk-feature-item" key={index}>
                            <img src={CompactLogo} alt="ROKK" className="rokk-feature-bullet" />
                            <p className="rokk-feature-text">{feature}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Pick Your Edition */}
            <div className="rokk-editions-intro">
                <div className="rokk-editions-intro-header">
                    <span className="head-txt-off-white">{t('rokk.editionsTitle1')}</span>
                    <span className="head-txt-primary">{t('rokk.editionsTitle2')}</span>
                    <br />
                    <span className="head-txt-off-white">{t('rokk.editionsTitle3')}</span>
                </div>
            </div>

            {/* Edition Cards */}
            <div className="rokk-editions-section">

                {/* Metal Edition */}
                <div className="rokk-edition-card">
                    <div className="rokk-edition-card-header">
                        <span className="rokk-edition-badge rokk-edition-badge-metal">{t('rokk.metalBadge')}</span>
                    </div>
                    <div className="rokk-edition-card-body">
                        <div className="rokk-edition-info">
                            <div className="rokk-edition-title">{t('rokk.metalTitle')}</div>
                            <span className="rokk-edition-tagline">{t('rokk.metalTagline')}</span>
                            <div className="rokk-edition-description">
                                <p>{t('rokk.metalDesc1')}</p>
                                <p>{t('rokk.metalDesc2')}</p>
                                <p>{t('rokk.metalDesc3')}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Standard Edition */}
                <div className="rokk-edition-card">
                    <div className="rokk-edition-card-header">
                        <span className="rokk-edition-badge rokk-edition-badge-standard">{t('rokk.standardBadge')}</span>
                    </div>
                    <div className="rokk-edition-card-body">
                        <div className="rokk-edition-info">
                            <div className="rokk-edition-title">{t('rokk.standardTitle')}</div>
                            <span className="rokk-edition-tagline">{t('rokk.standardTagline')}</span>
                            <div className="rokk-edition-description">
                                <p>{t('rokk.standardDesc1')}</p>
                                <p>{t('rokk.standardDesc2')}</p>
                                <p>{t('rokk.standardDesc3')}</p>
                            </div>
                            <p className="rokk-edition-feature-note">
                                {t('rokk.standardFeatureNote')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Newsletter */}
            <div className="rokk-newsletter-section">
                <div className="newsletter-container-pricing-page flex aln-items-cnt">
                    <div className="newsletter-section-header flex flex-dir-col">
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.subscribeTo')}</span>
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.our')}
                            <span className="head-txt-primary">{t('newsletter.rokk')}</span>
                        </span>
                        <span className="head-txt-primary font-sz-small">{t('newsletter.newsletter')}</span>
                    </div>
                    <NewsletterForm />
                </div>
            </div>
        </div>
    )
}

export default RokkPage
